import { render, staticRenderFns } from "./StoreInfoRewards.vue?vue&type=template&id=23b22b05&scoped=true"
import script from "./StoreInfoRewards.vue?vue&type=script&lang=js"
export * from "./StoreInfoRewards.vue?vue&type=script&lang=js"
import style0 from "./StoreInfoRewards.vue?vue&type=style&index=0&id=23b22b05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b22b05",
  null
  
)

export default component.exports